'use client';

import type { PropsWithChildren} from 'react';
import { useCallback } from 'react';

import { subscribeToMagicIdNewsletter } from '@api';

import { NewsletterSubscriptionContextProvider } from '@ui/uikit/components/common/NewsletterSubscription';

const NewsletterSubscriptionProvider = ({ children }: PropsWithChildren) => {
  const handleSubscription = useCallback(async (email: string) => {
    await subscribeToMagicIdNewsletter({
      json: {
        email,
        group: 'MAGIC_STORE',
      },
    });
  }, []);

  return (
    <NewsletterSubscriptionContextProvider subscribe={handleSubscription}>
      {children}
    </NewsletterSubscriptionContextProvider>
  );
};

export { NewsletterSubscriptionProvider };
